module.exports = __webpack_public_path__ + "static/media/Bed.80942ed0.png";